import React from 'react';
import {FormattedMessage} from 'react-intl';

export default class FormCountrySelectField extends React.Component {
    static propTypes = {
        field: React.PropTypes.object.isRequired,
        countryCodeField: React.PropTypes.object.isRequired,
        countryNumberLengthField: React.PropTypes.object.isRequired,
        message: React.PropTypes.object.isRequired,
        options: React.PropTypes.array.isRequired,
        countries: React.PropTypes.object.isRequired,
        required: React.PropTypes.bool
    };

    static renderHint(hint) {
        return (
            <div className="hint hint--error">
                <FormattedMessage {...hint}/>
            </div>
        );
    }

    _handleOnChange = (e) => {
        const countryId = e.target.value;
        const country = this.props.countries[countryId];
        const countryCode = country.mask;
        const countryNumberLength = country.length;

        this.props.field.onChange(countryId);
        this.props.countryCodeField.onChange(countryCode);
        this.props.countryNumberLengthField.onChange(countryNumberLength);
    }

    render() {
        const notRequiredLabelClass = 'login--form__label form__label';
        const requiredLabelClass = 'login--form__label form__label form__label__required';
        const inputClass = 'login--form__control form__control';
        const rowClass = 'form__row';

        const {required, field, message, options, disabled} = this.props;

        const labelClass = required ? requiredLabelClass : notRequiredLabelClass;

        return (
            <div className={rowClass}>
                <label className={labelClass}>
                    <FormattedMessage {...message}/>
                </label>
                <select className={inputClass} value={field.value}
                        onChange={this._handleOnChange}
                        onBlur={field.onBlur}
                        disabled={disabled}>
                    {options}
                </select>
                {field.touched && field.error && FormCountrySelectField.renderHint(field.error)}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/FormCountrySelectField.jsx